import { render, staticRenderFns } from "./ListaBambini.vue?vue&type=template&id=d913de52"
import script from "./ListaBambini.vue?vue&type=script&lang=js"
export * from "./ListaBambini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports